import platform from './platform';

// What this application is called, and who publishes it.
//
// THE APPLICATION IS NOT THE COMPANY. "Flexi Network" is the company that
// publishes Flexi Domains, Flexi Email, Flexi Bot. Customer-facing copy
// names the APPLICATION, so a customer who runs two of our products can
// tell which one is asking them for something.
//
// FNP-1367 is why this file is required: 29 customer-facing strings in
// flexi-domains-app said "Flexi" when the application is "Flexi Domains".
// FNP-1413 found the same in flexi-bot-app, hand-typed in five places
// that already disagreed with each other.
//
// Read the name from here. Never type it into a component.
// In translated strings keep it as a {product} token — I18n.get() keys on
// the English text, so interpolating the name orphans every translation.
//
// Flexi Directory and flexinet-directory-app are substituted by the seeder.
const product = {
    // Machine name: the repo / package / subdomain slug, e.g. 'flexi-domains'.
    name: platform.appName,

    // Customer-facing application name, e.g. 'Flexi Domains'. This is the
    // string that appears in headings, emails and consent copy.
    displayName: platform.displayName,

    // One-line description of what this application does.
    description: platform.description,

    // The company that publishes this application. Same for every app on
    // the platform — do not change this per app.
    publisher: 'Flexi Network',

    // Support contact surfaced in error states and footers.
    // FILL IN: replace with this application's own support alias if it has
    // one; otherwise leave the platform default.
    supportEmail: 'support@flexi.network',
};

export default product;
